import { FormattedMessage } from 'react-intl';

import ExclamationCircleIcon from '@/assets/icons/exclamation-circle.svg';
import { Typography } from '@/components/ui/typography';

export function DurationLockedBanner() {
  return (
    <div className="bg-fx-amber-50 flex items-center gap-2 rounded p-2">
      <img src={ExclamationCircleIcon} alt="" />
      <Typography variant="body1">
        <FormattedMessage
          defaultMessage="Duration is locked once the campaign starts and can't be changed."
          description="Warning banner when a started Talroo campaign's dates cannot be edited; budget may still change"
        />
      </Typography>
    </div>
  );
}
